import React, { useState, useContext } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

import logoImage from "../../images/mini-logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import MyContext from "../../MyContext";

const customStyles = `
  .login-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #0052D4, #4364F7, #6FB1FC);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .login-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 2rem;
    width: 100%;
    max-width: 450px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  // .login-card:hover {
  //   transform: translateY(-5px);
  //   box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  // }

  .logo-container {
    width: 100px;
    height: 100px;
    // background: linear-gradient(45deg, #0052D4, #4364F7);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 2rem;
    color: white;
    font-size: 2rem;
    font-weight: bold;
    animation: logoFloat 3s ease-in-out infinite;
  }

  @keyframes logoFloat {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }

  .form-floating {
    margin-bottom: 1.5rem;
    position: relative;
  }

  .form-control {
    height: 55px;
    border-radius: 12px;
    padding-left: 45px !important;
    border: 2px solid #e0e0e0;
    transition: all 0.3s ease;
  }

  .form-control:focus {
    border-color: #4364F7;
    box-shadow: 0 0 0 0.25rem rgba(67, 100, 247, 0.1);
  }

  .input-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    z-index: 2;
  }

  .btn-primary {
    height: 50px;
    border-radius: 12px;
    background: linear-gradient(45deg, #0052D4, #4364F7);
    border: none;
    font-weight: 600;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(67, 100, 247, 0.4);
  }

  .btn-primary:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: 0.5s;
  }

  .btn-primary:hover:before {
    left: 100%;
  }

  .slide-up {
    animation: slideUp 0.5s ease forwards;
  }

  .slide-down {
    animation: slideDown 0.5s ease forwards;
  }

  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  @keyframes slideDown {
    from { transform: translateY(-20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  .remember-forgot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .form-check-input:checked {
    background-color: #4364F7;
    border-color: #4364F7;
  }

  .form-check-label, .forgot-link {
    color: #6c757d;
    font-size: 0.9rem;
  }

  .forgot-link {
    text-decoration: none;
    color: #4364F7;
    transition: color 0.3s ease;
  }

  .forgot-link:hover {
    color: #0052D4;
  }

  .otp-info {
    color: #6c757d;
    font-size: 0.9rem;
    margin-top: 0.5rem;
    text-align: center;
  }

  .back-button {
    background: none;
    border: none;
    color: #4364F7;
    padding: 0;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .back-button:hover {
    color: #0052D4;
    transform: translateX(-5px);
  }
`;

const LoginPage = () => {
  const { baseUrl, config, config2 } = useContext(MyContext);

  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [step, setStep] = useState(1);
  const [isOTPVisible, setIsOTPVisible] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!mobileNumber || !password) {
      toast.error("Please fill in all fields");
      return;
    }
    loginHandler();
  };

  const handleOTPSubmit = (e) => {
    e.preventDefault();
    if (!otp || otp.length < 6) {
      toast.error("OTP must be at least 6 digits");
      return;
    }
    loginHandler();
  };

  const sendOtp = async () => {
    try {
      const payload = {
        mobile: mobileNumber,
        password: password,
        step: "1",
        otp: "",
        latitude,
        longitude,
      };

      const response = await axios.post(`${baseUrl}/api/Admin/login`, payload, config2);
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setStep(2);
        setIsOTPVisible(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("OTP Send Error:", error);
    }
  };

  const verifyOtp = async () => {
    try {
      const payload = {
        mobile: mobileNumber,
        password: password,
        step: "2",
        otp,
        latitude,
        longitude,
      };

      const response = await axios.post(`${baseUrl}/api/Admin/login`, payload, config);
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        sessionStorage.setItem("AdminUser", JSON.stringify(response.data.response));
        window.location.href = "/Admin/dashboard";
        setTimeout(() => window.location.reload(), 1000);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("OTP Verify Error:", error);
    }
  };

  const loginHandler = async () => {
    if (step === 1) {
      await sendOtp();
    } else if (step === 2) {
      await verifyOtp();
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <style>{customStyles}</style>
      <div className="login-container">
        <div className="login-card">
          <div className="logo-container">
            <img src={logoImage} alt="Logo" className="w-100" />
          </div>

          <div className="text-center mb-4">
            <h2 className="fw-bold mb-2">Admin Login</h2>
            <p className="text-muted">Welcome back! Please enter your details.</p>
          </div>

          {!isOTPVisible ? (
            <Form onSubmit={handleSubmit} className="slide-up">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Group className="form-floating">
                <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                <Form.Control
                  type="tel"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  placeholder="Enter your mobile number"
                />
              </Form.Group>

              <Form.Label>Password</Form.Label>
              <Form.Group className="form-floating">
                <FontAwesomeIcon icon={faLock} className="input-icon" />
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
              </Form.Group>

              <div className="remember-forgot">
                <Form.Check type="checkbox" label="Remember me" />
                <a href="#" className="forgot-link">Forgot password?</a>
              </div>

              <Button type="submit" className="w-100 btn-primary">Continue</Button>
            </Form>
          ) : (
            <Form onSubmit={handleOTPSubmit} className="slide-down">
              <Form.Label>Enter OTP</Form.Label>
              <Form.Group className="form-floating">
                <Form.Control
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 6-digit OTP"
                  maxLength="6"
                />
              </Form.Group>
              <p className="otp-info">OTP has been sent to your registered mobile number</p>
              <div className="d-flex justify-content-between align-items-center mt-4">
                <button
                  type="button"
                  className="back-button"
                  onClick={() => {
                    setIsOTPVisible(false);
                    setStep(1);
                  }}
                >
                  ← Back to login
                </button>
                <Button type="submit" style={{ width: "120px" }}>Verify OTP</Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginPage;
